import { css } from 'linaria';
export const defaultTheme = css `
  --color-primary: #ee4d2d;
  --color-secondary: #26aa99;
  --color-gradient-start: #ee4524;
  --color-gradient-end: #f75838;
`;
